const PastYear1819 = () => {

    const styles = {
        container: {
            height: "auto",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            color: "white"
        },
        content: {
            position: "relative" as "relative",
            height: "auto",
            maxHeight: "95%",
            width: "95%",
            maxWidth: "1280px",
            fontSize: "22px",
            fontFamily: "'Raleway', Arial",
            padding: "130px 0px",
            margin: "auto",
            verticalAlign: "middle",
            textAlign: "center" as "center",
        },
        contentAlt: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            //position: "relative",
            display: "block",
            height: "100%",
            width: "100%",
            color: "#FFF",
            fontSize: "20px",
            fontWeight: "300",
            fontFamily: "'Raleway', Arial, sans-serif",
            padding: "100px 0px",
            margin: "auto",
            verticalAlign: "middle",
            textAlign: "center" as "center",
        },
        sectionTitle: {
            fontSize: "32px",
            margin: "0px",
            fontWeight: "normal",
        },
        sectionTitleAlt: {
            color: "#FFF",
            fontSize: "32px",
            paddingBottom: "20px",
            margin: "0px",
            fontWeight: "normal",
        },
        newsArticles: {
            width: "95%",
            maxWidth: "1280px",
            textAlign: "left" as "left",
            margin: "30px auto",
            fontWeight: "300",
        },
        button: {
            margin: "10px",
            padding: "10px 20px",
            fontSize: "18px",
            backgroundColor: "#141619",
            color: "white",
            border: "1px solid #ddd",
            borderRadius: "8px",
            cursor: "pointer",
        },
        activeButton: {
            backgroundColor: "#050A44",
        },
    }
    return (
        <div className="container" style={styles.container}>
            <div className="content"
            style={{
                ...styles.content,
                color: "white",
                backgroundColor: "#141619",
                maxWidth: 1280,
                margin: "0px auto 0px",
            }}>
                <h1 style={{ color: "#2c45f5", fontSize: "60px", alignContent: "center", fontFamily: "'NCAA Missouri Tigers', Arial", }}>Subby</h1>
                <p className="sectionTitle" style={styles.sectionTitle}>2018-2019</p>
                <br />
                <div style={{padding: 20}}>
                <img
                    src="/images/viewPhotos/isoView.png"
                    alt="isoView"
                    id="subImg"
                    style={{ 
                        padding: "clamp(15px, 5vw, 40px)", 
                        borderRadius: "8px",
                        backgroundColor: "#DDD",
                        maxWidth: "100%",
                        width: "clamp(250px, 90vw, 800px)",
                        height: "auto",
                        objectFit: "contain"
                    }}
                />
                </div>
                <img
                    src="/images/viewPhotos/sideView.png"
                    alt="topView"
                    style={{
                        maxWidth: "clamp(150px, 30vw, 250px)",
                        height: "auto",
                        verticalAlign: "middle",
                        padding: "clamp(10px, 3vw, 40px)",
                        borderRadius: "clamp(15px, 5vw, 40px)",
                        backgroundColor: "#DDD",
                        margin: "10px",
                        display: "inline-block"
                    }}
                />
                <img
                    src="/images/viewPhotos/topView.png"
                    alt="frontView"
                    style={{
                        maxWidth: "clamp(180px, 35vw, 300px)",
                        height: "auto",
                        verticalAlign: "middle",
                        padding: "clamp(10px, 3vw, 40px)",
                        borderRadius: "clamp(15px, 5vw, 40px)",
                        backgroundColor: "#DDD",
                        margin: "clamp(10px, 3vw, 40px)",
                        display: "inline-block"
                    }}
                />
                <img
                    src="/images/viewPhotos/frontView.png"
                    alt="topView"
                    style={{
                        maxWidth: "clamp(150px, 30vw, 250px)",
                        height: "auto",
                        verticalAlign: "middle",
                        padding: "clamp(10px, 3vw, 40px)",
                        borderRadius: "clamp(15px, 5vw, 40px)",
                        backgroundColor: "#DDD",
                        margin: "10px",
                        display: "inline-block"
                    }}
                />
                <br />
                <br />
                <br />
            </div>
        </div>
    )
}

export default PastYear1819;